<div class="result-container">
  <div class="header">
    {{ CONSTANTS.RESULTS }}
  </div>
  <ion-row>
    <ion-col size="12">
      {{ CONSTANTS.FILE_NAME }}:
      {{ response.fileName }}
    </ion-col>
    @if (response.fileSize) {
      <ion-col size="12">
        {{ CONSTANTS.FILE_SIZE }}: {{ response.fileSize | fileSize }}
      </ion-col>
    }
    <ion-col size="12">
      {{ CONSTANTS.UNIQUE_ID }} : {{ response.uniqueUploadId }}
    </ion-col>
    @if (response.received) {
      <ion-col size="12">
        {{ CONSTANTS.ROWS }} : {{ response.received }}
      </ion-col>
    }
  </ion-row>
  <ion-row>
    <!-- RECORDS ACCEPTED -->
    <ion-col size="4">
      <div class="sub-headers">{{ CONSTANTS.RECORDS_ACCEPTED }}</div>
      <div>{{ response.accepted }}</div>
    </ion-col>

    <!-- RECORDS REJECTED -->
    <ion-col size="4">
      <div class="sub-headers">{{ CONSTANTS.RECORDS_REJECTED }}</div>
      <div>{{ response.rejected.length }}</div>
    </ion-col>

    <ion-col size="4">
      <div class="sub-headers">{{ CONSTANTS.NON_PROCESSED }}</div>
      <div>{{ response.itemsNonProcessed.length }}</div>
    </ion-col>
  </ion-row>
  @if (response.rejected.length > 0 || response.itemsNonProcessed.length > 0) {
    <ion-row>
      <!-- Items Rejected -->
      <ion-col size="6">
        <div class="sub-headers">{{ CONSTANTS.ERROR_RECORDS_REJECTED }}</div>
        <div class="container">
          @for (val of response.rejected; track val) {
            <div>{{ val }}</div>
          }
        </div>
      </ion-col>

      <!-- Items Not Processed-->
      <ion-col size="6">
        <div class="sub-headers">
          {{ CONSTANTS.ERROR_RECORDS_NON_PROCESSED }}
        </div>
        <div class="container">
          @for (val of response.itemsNonProcessed; track val) {
            <div>{{ val }}</div>
          }
        </div>
      </ion-col>
    </ion-row>
  }
</div>
